import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/commerce-php/commerce-php/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const InlineAlert = makeShortcode("InlineAlert");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "urn-schema-validation"
    }}>{`URN schema validation`}</h1>
    <p>{`Each module can contain XSD files for XML validation.`}</p>
    <p>{`The application uses `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Uniform_Resource_Name"
      }}>{`Uniform Resource Names`}</a>{` (URNs) to reference XML schema declarations.`}</p>
    <p>{`The application supported URNs begin with `}<inlineCode parentName="p">{`urn:magento`}</inlineCode>{`. The application supports two XSD reference types:`}</p>
    <ul>
      <li parentName="ul">{`Module XSD`}</li>
      <li parentName="ul">{`Framework XSD`}</li>
    </ul>
    <InlineAlert variant="info" slots="text" mdxType="InlineAlert" />
    <p>{`You cannot change the XSD for any XML files provided with the Adobe Commerce and Magento Open Source applications.`}</p>
    <h3 {...{
      "id": "module-xsd"
    }}>{`Module XSD`}</h3>
    <p>{`The syntax for the module XSD is a colon separated declaration. An example follows:`}</p>
    <p><inlineCode parentName="p">{`urn:magento:module:Magento_Flow:flows/content.xsd`}</inlineCode></p>
    <p>{`where`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`urn:magento`}</inlineCode>{` is the URN identifier`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`module`}</inlineCode>{` is the reference type identifier`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`Magento_Flow`}</inlineCode>{` is the name of the module. This must be exactly the same as the module specified by ComponentRegistrar in the `}<a parentName="li" {...{
          "href": "component-registration.md"
        }}>{`registration.php`}</a>{` file.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`flows/content.xsd`}</inlineCode>{` is the relative path to the module`}{`’`}{`s directory.`}</li>
    </ul>
    <h3 {...{
      "id": "framework-xsd"
    }}>{`Framework XSD`}</h3>
    <p>{`The syntax for the framework XSD is a colon separated declaration. An example follows:`}</p>
    <p><inlineCode parentName="p">{`urn:magento:framework:Api/etc/extension_attributes.xsd`}</inlineCode></p>
    <p>{`where`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`urn:magento`}</inlineCode>{` is the URN identifier`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`framework`}</inlineCode>{` is the reference type identifier. You can also add additional framework libraries as separate components with `}<inlineCode parentName="li">{`framework-<sub-name>`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`Api/etc/extension_attributes.xsd`}</inlineCode>{` is the relative path to the framework`}{`’`}{`s directory.`}</li>
    </ul>
    <h3 {...{
      "id": "referencing-a-xsd-from-another-xsd"
    }}>{`Referencing a XSD from another XSD`}</h3>
    <p>{`Use URN notation to reference schema from inside a XSD document:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-xml"
      }}>{`
<xs:redefine schemaLocation="urn:magento:framework:Config/etc/view.xsd">

`}</code></pre>
    <p>{`The URN resolution is invoked automatically by the libxml engine. Register the URN resolver by using `}<inlineCode parentName="p">{`libxml_set_external_entity_loader`}</inlineCode>{`:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-xml"
      }}>{`libxml_set_external_entity_loader(['Magento\\Framework\\Config\\Dom\\UrnResolver', 'registerEntityLoader']);
`}</code></pre>
    <InlineAlert variant="info" slots="text" mdxType="InlineAlert" />
    <p>{`The relative path to other XSDs cannot be used from inside the XSD file, because the entity loader fails to resolve the relative path.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      